export enum BooleanField {
    'NON', 'OUI'
}
